import EventHandler from 'bootstrap/js/src/dom/event-handler';

export const initBlog = () => {
  document.addEventListener('DOMContentLoaded', function () {
    init();
  });
};

function init() {
  const blogRootEl = document.querySelector('[data-blog-root-id]');
  if (!blogRootEl) return;
  const blogRootId = parseInt(blogRootEl.getAttribute('data-blog-root-id'), 10);
  const featuredId = blogRootEl.getAttribute('data-featured-id')
    ? parseInt(blogRootEl.getAttribute('data-featured-id'), 10)
    : null;
  const itemsPerLoad = parseInt(blogRootEl.getAttribute('data-items-per-load') || '9', 10);

  const container = blogRootEl.querySelector('.items-container');
  const loadMoreBtn = blogRootEl.querySelector('.buttons-block button');
  const noResultsEl = blogRootEl.querySelector('.no-results');
  const searchInput = document.getElementById('searchByKeyword');
  const filterByCategorySelect = document.getElementById('filterByCategorySelect');
  const filterByTopicSelect = document.getElementById('filterByTopicSelect');
  const filterSortSelect = document.getElementById('filterSortSelect');
  const filterSortBy = document.getElementById('filterSortBy');

  let searchTimeout;

  let state = {
    page: 1,
    pageSize: itemsPerLoad,
    category: parseListParam(new URLSearchParams(window.location.search).get('category')),
    topic: parseListParam(new URLSearchParams(window.location.search).get('topic')),
    keyword: new URLSearchParams(window.location.search).get('keyword') || '',
    sort: new URLSearchParams(window.location.search).get('sort') || 'latest',
  };

  const qs = (obj = null) => {
    if (!obj) return new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    Object.keys(obj).forEach(k => {
      if (obj[k] == null) return;
      params.set(k, obj[k]);
    });
    return params;
  };

  function slugify(s) {
    return (s || '').toString().toLowerCase().replace(/\s+/g, '-');
  }

  function parseListParam(v) {
    if (!v) return [];
    return v
      .split(',')
      .map(x => x.trim())
      .filter(Boolean);
  }

  async function fetchItems(opts) {
    const params = {
      blogRootId: opts.blogRootId,
      page: opts.page || 1,
      pageSize: opts.pageSize || 9,
      category: opts.category && opts.category.length ? opts.category.join(',') : null,
      topic: opts.topic && opts.topic.length ? opts.topic.join(',') : null,
      keyword: opts.keyword || null,
      sort: opts.sort || 'latest',
      featuredId: opts.featuredId || null,
    };
    const u = '/api/blog/items?' + qs(params).toString();
    const res = await fetch(u);
    if (!res.ok) throw new Error('Failed to load');
    return await res.json();
  }

  function updateUrl() {
    const p = new URLSearchParams();
    if (state.keyword) p.set('keyword', state.keyword);
    if (state.category && state.category.length) p.set('category', state.category.join(','));
    if (state.topic && state.topic.length) p.set('topic', state.topic.join(','));
    if (state.sort) p.set('sort', state.sort);

    const qsStr = p.toString();
    const base = window.location.pathname.replace(/\/+$/, '');
    const newUrl = qsStr ? `${base}?${qsStr}` : base;
    window.history.replaceState({}, '', newUrl);
  }

  function renderItems(items, append) {
    if (!append) container.innerHTML = '';
    items.forEach(i => {
      const el = document.createElement('div');
      el.className = 'widget-card_article widget-card card bg-white with-stretched-link';
      el.innerHTML = `
<div class="card-img-block ratio ratio-16x9 ratio-lg-3x2">
<div class="card-tags">
${i.topics && i.topics.length ? `<span class="badge badge-beige badge-xs">${i.topics[0]}</span>` : ''}
</div>
<div class="img-block" style="--bs-bg-image: url(${i.imageUrl || '../images/temp/img-2.jpg'})"></div>
</div>
<div class="card-body">
<p class="card-meta">
<span>${i.date}</span><span>${i.category || ''}</span>
</p>
<h5 class="card-title"><a href="${i.url}" class="stretched-link">${i.title}</a></h5>
<div class="row align-items-center">
<div class="col">
  <p class="card-text">${i.shortDescription || ''}</p>
</div>
<div class="col-auto flex-shrink-0">
  <a href="${i.url}" class="btn btn-icon btn-lg btn-opacity-primary rounded-circle stretched-link">
    <svg class="svg-icon icon-arrow-up-right"><use xlink:href="/images/spritemap/spritemap.svg#icon-arrow-up-right"></use></svg>
  </a>
</div>
</div>
</div>
`;
      container.appendChild(el);
    });
  }

  async function load(reset) {
    if (reset) state.page = 1;
    try {
      const data = await fetchItems({
        blogRootId,
        page: state.page,
        pageSize: state.pageSize,
        category: state.category,
        topic: state.topic,
        keyword: state.keyword,
        sort: state.sort,
        featuredId,
      });

      if (reset) renderItems(data.items, false);
      else renderItems(data.items, true);

      if (data.hasMore) {
        loadMoreBtn?.classList.remove('d-none');
      } else {
        loadMoreBtn?.classList.add('d-none');
      }

      noResultsEl?.classList.toggle('d-none', data.total > 0);
    } catch (e) {
      console.error(e);
    }
  }

  searchInput?.addEventListener('input', function () {
    const value = this.value.trim();

    clearTimeout(searchTimeout);

    searchTimeout = setTimeout(() => {
      if (value === state.keyword) return;

      state.keyword = value;
      updateUrl();
      load(true);
    }, 350);
  });

  filterByCategorySelect?.addEventListener('change', function (e) {
    const opts = Array.from(this.selectedOptions).map(o => o.value);
    state.category = opts;
    updateUrl();
    load(true);
  });

  filterByTopicSelect?.addEventListener('change', function (e) {
    const opts = Array.from(this.selectedOptions).map(o => o.value);
    state.topic = opts;
    updateUrl();
    load(true);
  });

  filterSortSelect?.addEventListener('change', function (e) {
    state.sort = this.value === 'value1' ? 'latest' : this.value === 'value2' ? 'popular' : 'oldest';
    updateUrl();
    load(true);
  });

  filterSortBy?.addEventListener('change', function (e) {
    state.sort = this.value === 'value1' ? 'latest' : this.value === 'value2' ? 'popular' : 'oldest';
    updateUrl();
    load(true);
  });

  loadMoreBtn?.addEventListener('click', function (e) {
    state.page++;
    load(false);
  });

  if (searchInput) searchInput.value = state.keyword || '';

  if (filterByCategorySelect) {
    Array.from(filterByCategorySelect.options).forEach(o => {
      o.selected = state.category.includes(o.value);
    });
    // Trigger Tom Select update if available
    if (filterByCategorySelect.tomselect) {
      filterByCategorySelect.tomselect.setValue(state.category);
    }
  }

  if (filterByTopicSelect) {
    Array.from(filterByTopicSelect.options).forEach(o => {
      o.selected = state.topic.includes(o.value);
    });
    // Trigger Tom Select update if available
    if (filterByTopicSelect.tomselect) {
      filterByTopicSelect.tomselect.setValue(state.topic);
    }
  }

  // Set sort value on page load for both mobile and desktop
  const sortValue = state.sort === 'popular' ? 'value2' : state.sort === 'oldest' ? 'value3' : 'value1';
  if (filterSortSelect) {
    filterSortSelect.value = sortValue;
    // Trigger Tom Select update if available
    if (filterSortSelect.tomselect) {
      filterSortSelect.tomselect.setValue(sortValue);
    }
  }
  if (filterSortBy) {
    filterSortBy.value = sortValue;
    // Trigger Tom Select update if available
    if (filterSortBy.tomselect) {
      filterSortBy.tomselect.setValue(sortValue);
    }
  }

  load(true);
}
